/* Publish by EComposer at 2026-11-04 10:17:35*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4k1g2iafm5"]=  window.__ectimmers["ecom-4k1g2iafm5"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-4k1g2iafm5"]["auyzz9n45"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let n=this.$el;if(!n)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=n.querySelector(".ecom-element.ecom-base-image"),a=n.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-4k1g2iafm5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-4k1g2iafm5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-4k1g2iafm5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gw9wt726x4h').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gw9wt726x4h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gw9wt726x4h', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-9ese8lra7pk').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-9ese8lra7pk', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-9ese8lra7pk', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-e2emk4xfl7d').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-e2emk4xfl7d', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-e2emk4xfl7d', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-ob6n9wk46i').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-ob6n9wk46i', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-ob6n9wk46i', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-iddkwh3mzq').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-iddkwh3mzq', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-iddkwh3mzq', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-bksnc5sq78t').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-bksnc5sq78t', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-bksnc5sq78t', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-a02f625wyx').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-a02f625wyx', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-a02f625wyx', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-3y3ifhu4ho7').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-3y3ifhu4ho7', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-3y3ifhu4ho7', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-i223q2g6r5').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-i223q2g6r5', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-i223q2g6r5', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-upl4j79g8t').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-upl4j79g8t', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-upl4j79g8t', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-yymvo8yokjs').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-yymvo8yokjs', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-yymvo8yokjs', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-o3q6v1q21ao').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-o3q6v1q21ao', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-o3q6v1q21ao', e);
                            }
                        });
                    
                        document.querySelectorAll('.ecom-gugebu7r0m9').forEach(function(el){
                            try {
                                Func.call({$el: el, id: 'ecom-gugebu7r0m9', settings: {"link":"custom","lightbox":"no","highligh_on_viewport":false},isLive: true});
                            } catch (e) {
                                console.error('[EComposer] ecom-gugebu7r0m9', e);
                            }
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}